import React, { useState, useEffect } from "react";
import "./style.css";
import MasterControlProperty from "../MasterControlProperty";
import MasterControlAuto from "../MasterControlAuto";
import MasterControlUmbrella from "../MasterControlUmbrella";

function AgentMasterControl({ agentProperties, agentAutos, agentUmbrellas, agentID }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    DOB: "",
    email: "",
    streetAddress: "",
    cityAddress: "",
    zipAddress: "",
    stateAddress: "",
    quoteNotes: "",
    totalPremiums: 0
  });

  useEffect(() => {
    console.log("Contact Card Mounted");
    setTimeout(() => {
      calculateTotals();
    }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const calculateTotals = () => {
    let autoPrems = 0;
    let homePrems = 0;
    let umbrellaPrems = 0;

    for (let i = 0; i < agentAutos.length; i++) {
      autoPrems += agentAutos[i].premium;
    }

    for (let j = 0; j < agentProperties.length; j++) {
      homePrems += agentProperties[j].premium;
    }

    for (let k = 0; k < agentUmbrellas.length; k++) {
      umbrellaPrems += agentUmbrellas[k].premium;
    }

    setTimeout(() => {
      console.log("Auto premiums: " + autoPrems);
      console.log("Home premiums: " + homePrems);
      console.log("Umbrella premiums: " + umbrellaPrems);
    }, 1000);

    setFormData((prev) => ({
      ...prev,
      totalPremiums: autoPrems + homePrems + umbrellaPrems
    }));
  };

  const { totalPremiums } = formData;

  return (
    <div
      className="card mb-3"
      style={{
        overflow: "auto",
        padding: "0px",
        textAlign: "center",
        backgroundColor: "rgba(0,0,0,0.2)",
        height: "900px"
      }}
    >
      <div className="row">
        <div className="col-6 offset-3" style={{ textAlign: "center" }}>
          <table striped="true" style={{ display: "inline" }}>
            <thead>
              <tr style={{ width: "100%" }}>
                <th>Policies</th>
                <th>Premiums</th>
                <th>Estimated Commissions</th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "white" }}>
              <tr>
                <td>{agentAutos.length + agentProperties.length + agentUmbrellas.length}</td>
                <td>{totalPremiums}</td>
                <td>{(totalPremiums * 0.025).toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col">
          <table style={{ backgroundColor: "transparent", display: "inline" }}>
            <thead>
              <tr style={{ textColor: "black" }}>
                <th>Type</th>
                <th>Client Name</th>
                <th>Status</th>
                <th>Premium</th>
                <th>Split</th>
                <th>Est. Comm</th>
                <th>Renewal Date</th>
                <th>Date Updated</th>
                <th>Date Added</th>
                <th>View Client</th>
              </tr>
            </thead>
            <tbody>
              {agentProperties ? (
                <>
                  {agentProperties.map((property) => (
                    <MasterControlProperty
                      key={property.tempID}
                      property={property}
                      agentID={agentID._id}
                    />
                  ))}
                </>
              ) : null}

              {agentAutos ? (
                <>
                  {agentAutos.map((auto) => (
                    <MasterControlAuto key={auto.tempID} auto={auto} agentID={agentID._id} />
                  ))}
                </>
              ) : null}

              {agentUmbrellas.map((umbrella) => (
                <MasterControlUmbrella
                  key={umbrella.tempID}
                  umbrella={umbrella}
                  agentID={agentID._id}
                />
              ))}
              <tr></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AgentMasterControl;
